import { SET_PACKAGE, PACKAGE_ERROR } from '../actions/quote'
import brands from '../configuration/brands'
import { getActivePackageData } from './activePackage'
const initialState = {
  hasErrors: false,
  isLoading: false
}

const packageDetails = (state = initialState, action) => {
  switch (action.type) {
    case SET_PACKAGE:
      return Object.assign({}, state, {
        info: action.payload
      })
    case PACKAGE_ERROR:
      return Object.assign({}, state, {
        hasErrors: true
      })
    default:
      return state
  }
}

export default packageDetails

export const getItinerary = state => {
  const identifier = state.activePackage

  // Prefer the itinerary fetched from the dedicated itinerary endpoint (it
  // includes pre/post cruisetour days). Fall back to the itinerary embedded in
  // the quote package, which only contains the sailing days.
  const fetchedItinerary =
    state.itineraryData &&
    state.itineraryData.itineraries &&
    state.itineraryData.itineraries[identifier]
  if (fetchedItinerary && fetchedItinerary.length) {
    return fetchedItinerary
  }

  return state.availablePackages &&
    state.availablePackages[identifier] &&
    state.availablePackages[identifier].itinerary
    ? state.availablePackages[identifier].itinerary
    : null
}

export const getFeaturedItineraryImage = state => {
  const itinerary = getItinerary(state)
  if (!itinerary) {
    return null
  }

  return itinerary.find(port => port.isFeatured)
}

export const getBrandClassName = state => {
  // return 'celebrity'
  // return 'royal'
  // return 'azamara'
  // return 'default'

  return state.activePackage &&
    state.availablePackages &&
    state.availablePackages[state.activePackage] &&
    state.availablePackages[state.activePackage].brand &&
    brands[state.availablePackages[state.activePackage].brand]
    ? brands[state.availablePackages[state.activePackage].brand].className
    : 'default'
}

export const getCruiseTourDetails = state => {
  const activePackage = getActivePackageData(state)

  if (!activePackage || activePackage.justACruise) {
    return null
  }

  const {
    postTourNights,
    preTourNights,
    postTourCity,
    preTourCity
  } = activePackage

  const itinerary = getItinerary(state)
  let embarkDay
  if (itinerary) {
    embarkDay = itinerary.find(day => day.activity === 'EMBARK')
  }

  return {
    postTourNights,
    preTourNights,
    postTourCity,
    preTourCity,
    embarkDay: embarkDay ? embarkDay.day : embarkDay
  }
}
